import React from 'react'
import { withQuiz } from '../Quiz'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'

class ExitEvent extends React.Component {
  componentDidMount() {
    this.props.app.toggleModal(null, 'logout')
  }

  render() {
    return null
  }
}

export default withApp(withQuiz(ExitEvent))
